import React from 'react'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const MusicList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props} />
)

export default MusicList
